import { removeItem } from 'services/localStorage/cache'
import { cache } from 'swr'

const clearCache = (applicationId: string) => {
  removeItem(`fetchLoanApplication:${applicationId}`)
  removeItem(`fetchUpsellMargin:${applicationId}`)
  removeItem(`fetchDocuments:${applicationId}`)

  cache.delete(`arg@"loan-application"@"${applicationId}"`)
  cache.delete(`arg@"cards"@"${applicationId}"`)
  cache.delete(`arg@"upsell-margin"@"${applicationId}"`)
  cache.delete(`arg@"documents"@"${applicationId}"`)
}

export { clearCache }
